
import {log,_} from '../globals'

class ApiFactory {
		
	$http:any;
	apiBase:any;
	apiServerUrl:any;
	callbackOrLog:any;	
	processHeaders:any;	
	sendHeaders:any;	
	prepareUrl:any;		
	buildUrlWithParams:any;  
	lowerCaseObjectKeys:any;
	lowerCaseObjectOfCollections:any;
	lowerCaseObjectOfObjsAndCollections:any;
	

	getUserToken:any;

	static $inject = ["$http","ApiBase"];
	constructor($http, apiBase) {
		this.$http = $http;
		this.apiBase = apiBase;
		this.apiServerUrl	= apiBase.apiServerUrl;
		this.callbackOrLog	= apiBase.callbackOrLog;
		this.processHeaders	= apiBase.processHeaders;
		this.sendHeaders		= apiBase.sendHeaders;
		this.prepareUrl		= apiBase.prepareUrl;
		this.buildUrlWithParams  = apiBase.buildUrlWithParams;
		this.lowerCaseObjectKeys				= apiBase.lowerCaseObjectKeys;
		this.lowerCaseObjectOfCollections	= apiBase.lowerCaseObjectOfCollections;
		this.lowerCaseObjectOfObjsAndCollections	= apiBase.lowerCaseObjectOfObjsAndCollections;

		this.getUserToken = apiBase.getUserToken;

	}
		

		// get(url,config) , post/put (url,data,config)
	   get(url,params,callback){
			this.$http.get(this.buildUrlWithParams(url,params), {})
				.success((data, status, headers) => {
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// url, param {}, 
		post(url,params,data,callback){
			this.$http.post(this.buildUrlWithParams(url,params), data,{})
				.success((data, status, headers)=> {
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		put(url,params,data,callback){
			this.$http.put(this.buildUrlWithParams(url,params), data,{})
				.success((data, status, headers) => {
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		sendPeformanceMetrics(metricJSON, performanceContext, callback) {
			this.$http.post(this.prepareUrl('/data/system/frontend-page-performance-metric'), {metricJSON: metricJSON}, this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		}

		getMySynchEnumerations(callback) {
			this.$http.get(this.prepareUrl('/data/service/mysynch-enumerations'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getMySynchEnumeration(enumType,enumKey,callback) {
			this.$http.post(this.prepareUrl('/data/service/mysynch-enumeration'),{enumType:enumType,enumKey:enumKey}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

//#region Hide 1
		createPasswordResetRecord(loginId, callback) {
			this.$http.post(this.prepareUrl('/data/password-reset'), {loginId: loginId}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		checkPasswordResetKey(passwordResetKey, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/password-reset/' + passwordResetKey), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updatePasswordByPasswordResetKey(passwordResetKey, data, callback) {
			this.$http.put(this.prepareUrl('/data/person/password/password-reset-key/' + passwordResetKey), {person: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		
		getReviewResultsAndDraft(auditId, performanceContext = null, callback) {
			this.$http.get(this.prepareUrl('/data/f360/review-results/' + auditId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		updateReviewResults(auditId,draftNotesJson,nextEvalDate, callback) {
			var data = {nextEvalDate:nextEvalDate,draftNotesJson:draftNotesJson };
			this.$http.put(this.prepareUrl('/data/f360/review-results/' + auditId),data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};


		getFertilityAnalysisByHerd(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/fertilityanalysis/' + herdId), this.sendHeaders(performanceContext)).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		getJournalByHerd(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/journal/' + herdId), this.sendHeaders(performanceContext)).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		getOneJournal(herdId, id, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/journal/' + herdId + '/id/' + id), this.sendHeaders(performanceContext)).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		deleteJournal(herdId, id, userId, callback) {
			this.$http.delete(this.prepareUrl('/data/journal/' + herdId + '/delete/' + id + '/user/' + userId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		
		createJournal(data, callback) {
			this.$http.post(this.prepareUrl('/data/journal/'	+ data.herdId + 
				'/user/' + data.userId), {journal: data}, this.sendHeaders())
					.success((data, status, headers) => {
						this.processHeaders(headers);
						this.callbackOrLog(callback, null, data || null); })
					.error((err) => {
						this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateJournal(data, callback) {
			this.$http.put(this.prepareUrl('/data/journal/update/'+ data.id), {journal: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getReportDetailsByReportCodeAndHerdId(data, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/report/details/report-code/' + data.reportCode + '/herd/' + data.herdId), this.sendHeaders(performanceContext)).then(
				(response) => {
					this.processHeaders(response.headers);
					var responseData = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, responseData || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		getFarm(farmId, callback) {
			this.$http.get(this.prepareUrl('/data/farm/' + farmId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getFarmsByPersonId(personId, callback) {
			this.$http.get(this.prepareUrl('/data/farm/person/' + personId), this.sendHeaders())
				.success((data, status, headers) =>  {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getFarmPermissionsByPersonId(personId, callback) {
			this.$http.get(this.prepareUrl('/data/farm/person/' + personId+'/farm-permissions'), this.sendHeaders())
				.success((data, status, headers) =>  {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		userHasNonDC305FarmsOnly(personId, callback) {
			this.$http.get(this.prepareUrl('/data/person/'+personId+'/non-dc305farms-only'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data[0]);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getFarmWithHerdsByFarmId(farmId, callback) {
			this.$http.get(this.prepareUrl('/data/farm/'+farmId+'/with-herds/'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data[0]);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAllActiveTestFarms(data, callback) {
			this.$http.get(this.prepareUrl('/data/farm/activeTestFarms'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getAllActiveTestFarmsForTerritoryDashboard(data, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/farm/territoryManager/activeTestFarms'), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getFarmsForTerritoryDashboard(territoryManagerId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/farm/territoryManager/' + territoryManagerId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAllInactiveFarmsForTerritoryDashboard(territoryManagerId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/farm/territoryManager/' + territoryManagerId+'/inactiveFarms'), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdsByFarmId(farmId, callback) {
			this.$http.get(this.prepareUrl('/data/herd/farm/' + farmId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerd(herdId, performanceContext = null, callback) {
			this.$http.get(this.prepareUrl('/data/herd/' + herdId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getUsersByFarmId(farmId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/user/farm/' + farmId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getHerdsByFarmIds(farmIdsJson, callback) {
			this.$http.post(this.prepareUrl('/data/herd/herds-by-farmIds'),{farmIdsJson:farmIdsJson}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdConcepDataByCodeAndHerdId(herdId,code, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/${herdId}/concep-data-by-code`),{code:code}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getHerdConcepDataBySwitchTypeAndHerdKey(herdId,herdKey,switchTypeJSON,lactGrpJSON, performanceContext, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/${herdId}/concep-data-by-code/multi`),{herdKey:herdKey,switchTypeJSON:switchTypeJSON,lactGrpJSON:lactGrpJSON}, this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAdditionalHerdDataByHerdIds(herdIdsJSON,callback){
			this.$http.post(this.prepareUrl('/data/herd/additionalherdata-by-herdIds'), {herdIdsJSON:herdIdsJSON}, this.sendHeaders())
				.success((serverData, status, headers) => {
					this.processHeaders(headers);
					var serverDataJson = _.get(serverData,'Data',"[]");
					var additionalHerdData = {};
					try{
						additionalHerdData = JSON.parse(serverDataJson);

					}catch(e){
						log.info("failed to parse returned AdditionalHerdData");  
					}
					if(!_.isEmpty(additionalHerdData)){
						additionalHerdData = _.map(additionalHerdData,this.lowerCaseObjectOfObjsAndCollections);
					}
					
					this.callbackOrLog(callback, null, additionalHerdData || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdPenLocations(herdId, performanceContext, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/pen-locations`),{herdId:herdId}, this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); 
				})
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			    });
		};

		upsertHerdPenLocations(herdId, penLocations, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/pen-locations/upsert`),{herdId:herdId, penLocations:penLocations}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); 
				})
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
				});
		};

		getFarmDemographicsData(herdId, performanceContext, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/farm-demographics`),{herdId:herdId}, this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					//data = _.map(data, this.lowerCaseObjectKeys);
					data = this.lowerCaseObjectOfCollections(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdSpecialReports(herdId,herdKey, performanceContext, callback){
			this.$http.post(this.prepareUrl('/data/herd/special-reports'),{herdId:herdId,herdKey:herdKey} ,this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					_.set(data,'viewableReports', _.map(_.get(data,'viewableReports',[]), this.lowerCaseObjectKeys));
					_.set(data,'downloadableReports', _.map(_.get(data,'downloadableReports',[]), this.lowerCaseObjectKeys));
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		}

		downloadSpecialReport(blobPath, performanceContext, callback){
			this.$http.post(this.prepareUrl('/data/azure-storage/special-report'),{blobPath:blobPath} ,_.merge(this.sendHeaders(performanceContext),{responseType: 'arraybuffer'}))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					var dataObj = {headers: headers, data: data};
					this.callbackOrLog(callback, null, dataObj || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		}

		getHerdFertilityCalendarsByHerdId(herdId,callback) {
			this.$http.post(this.prepareUrl(`/data/herd/fertility-calendars`),{herdId:herdId}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		createHerdFertilityCalendar(calendar, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/fertility-calendar/create`),{calendar:calendar}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateHerdFertilityCalendar(calendar, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/fertility-calendar/update`),{calendar:calendar}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		archiveHerdFertilityCalendar(calendarId, herdId, endDate, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/fertility-calendar/archive`),{calendarId:calendarId, herdId:herdId, endDate:endDate}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		deleteHerdFertilityCalendar(calendarId, herdId, callback) {
			this.$http.post(this.prepareUrl(`/data/herd/fertility-calendar/delete`),{calendarId:calendarId, herdId:herdId}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		}


		updateFarmDemographicsHerd(herd,callback) {
			this.$http.put(this.prepareUrl(`/data/herd/farm-demographics-herd`),{herd:herd}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
        };
		updateFarmDemographicsDetailsByHerdId(herdId,farmDemographicDetailsJson,callback) {
			this.$http.put(this.prepareUrl(`/data/herd/farm-demographics-details`),{herdId:herdId,farmDemographicDetailsJson:farmDemographicDetailsJson}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		inviteUsersToFarm(farm, users, sendToSuperAdmin, superAdminEmail, callback) {
			this.$http.post(this.prepareUrl('/data/user/farm/' + farm.farmId), {farm: farm, users: users, sendToSuperAdmin: sendToSuperAdmin, superAdminEmail: superAdminEmail}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updatePersonRoles(personRoles, callback) {
			this.$http.put(this.prepareUrl('/data/user/farm'), {personRoles: personRoles}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getStaticListData(callback) {
			this.$http.get(this.prepareUrl('/data/all'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(this.lowerCaseObjectOfCollections(data));	//	2 levels of key lowercasing
					this.callbackOrLog(callback, null, data); })
				.error((err, status) => {
					this.callbackOrLog(callback, (_.isUndefined(err) ? status : err));
			});
		};
		getUnCachedStaticListData(callback) {
			this.$http.get(this.prepareUrl('/data/all/nocache'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(this.lowerCaseObjectOfCollections(data));	//	2 levels of key lowercasing
					this.callbackOrLog(callback, null, data); })
				.error((err, status) => {
					this.callbackOrLog(callback, (_.isUndefined(err) ? status : err));
			});
		};

		createFarm(data, callback) {
			this.$http.post(this.prepareUrl('/data/farm'), {farm: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateFarmsStatus(data, callback) {
			this.$http.put(this.prepareUrl('/data/farms/status'), {farms: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateFarm(data, callback) {
			this.$http.put(this.prepareUrl('/data/farm/' + data.farmId), {farm: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
//#endregion Hide 1


		getFarmGoalMgmt(farmId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/farmgoalmgmt/' + farmId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateFarmGoalMgmt(data, callback) {
			console.log("updating farm goal data:");
			console.log(data);
			this.$http.put(this.prepareUrl('/data/farmgoalmgmt/update/' + data.farmId), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// --- Retrieve Action Items batches
		getAllActionItemsByHerdId(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/actionitemgroup/list/' + herdId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getAllActionItemsByGroupId(data, callback) {
			this.$http.get(this.prepareUrl('/data/actionitemgroup/' + data.herdId + '/Group/' + data.groupId), this.sendHeaders())
			.success((data, status, headers) => {
				this.processHeaders(headers);
				data = _.map(data, this.lowerCaseObjectKeys);
				this.callbackOrLog(callback, null, data || null); })
			.error((err) => {
				this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getAllActionItemsByAuditId(data, callback) {
			this.$http.get(this.prepareUrl('/data/actionitemgroup/' + data.herdId + '/Audit/' + data.auditId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		getAllActionItemsByGroupKey(data, callback) {
			this.$http.get(this.prepareUrl('/data/actionitemgroup/' + data.herdId + '/GroupKey/' + data.groupKey), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// --- f360 publish a batch of action item groups with their respective action items
		publishActionItemGroupDetails(auditId, data, callback) {
			this.$http.post(this.prepareUrl(`/data/actionitemgroup/publish/${auditId}`), {actionItemDetailsJson: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		
		// --- Action Item
		createActionItem(herdId, groupId, data, callback) {
			this.$http.post(this.prepareUrl(`/data/actionitem/herd/${herdId}/create/${groupId}`), {actionItem: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		updateActionItem(actionItemId, data, callback) {
			this.$http.put(this.prepareUrl(`/data/actionitem/update/${actionItemId}`), {actionItem: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// --- Action Item Group
		createActionItemGroup(herdId, data, callback) {
			this.$http.post(this.prepareUrl(`/data/actionitemgroup/create/HerdId/${herdId}`), {actionItemGroup: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		updateActionItemGroup(groupId, data, callback) {
			this.$http.put(this.prepareUrl(`/data/actionitemgroup/update/GroupId/${groupId}`), {actionItemGroup: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		

		// emm ---------

		getHerdShotListNames(herdId, callback) {
			this.$http.get(this.prepareUrl('/data/emm/herd-shotlists/' + herdId+'/names'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdShotListCustomFields(herdId,herdShotListId, callback) {
			this.$http.get(this.prepareUrl('/data/emm/herd-shotlists/' + herdId+'/'+herdShotListId+'/custom-fields'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};


		getHerdShotListConfig(herdId, callback) {
			this.$http.get(this.prepareUrl('/data/emm/herd-shotlist-config/' + herdId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdShotSessionListByHerdId(herdId, callback){
			this.$http.get(this.prepareUrl('/data/emm/herd-session/' + herdId+'/list'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};


		// dashboards --------
		getMultiFarmDashboard(personId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/dashboards/multi-farm-dashboard/' + personId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err)  => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// notifications --------
		getPersonAppLevelNotificationsExpiryDate(personId, herdId,notificationId, callback) {
			this.$http.get(this.prepareUrl('/data/notifications/expirydate/person/' + personId + '/herd/' + herdId + '/notification/' + notificationId ), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err)  => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		upsertPersonAppLevelNotification(personId, herdId,notificationId, expiryDate, callback) {
			this.$http.post(this.prepareUrl('/data/notifications/expirydate/upsert' ),{personId:personId,herdId:herdId,notificationId: notificationId, expiryDate: expiryDate} ,this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err)  => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

//#region Hide 2			
		activateUser(data, callback) {
			this.$http.put(this.prepareUrl('/data/user/' + data.personId + '/activate'), {person: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateUser(data, callback) {
			this.$http.put(this.prepareUrl('/data/user/' + data.personId), {person: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		loginAvailable(personId, loginId, callback) {
			this.$http.put(this.prepareUrl('/data/user/' + personId + '/login-available'), {personId: personId, loginId: loginId}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updatePassword(personId, password, callback) {
			this.$http.put(this.prepareUrl('/data/user/' + personId + '/password'), {personId: personId, password: password}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateHerd(data, callback) {
			this.$http.put(this.prepareUrl('/data/herd/' + data.herdId), {herd: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdUploadsByHerdId(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/herd-upload/herd/' + herdId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdFertilityPlansByHerdFertilityProgramIdAndParityTypeId(data, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/herd-fertility-plan/herd-fertility-program/' + data.herdFertilityProgramId + 
				'/parity-type/' + data.parityTypeId), this.sendHeaders(performanceContext))
					.success((data, status, headers) => {
						this.processHeaders(headers);
						data = _.map(data, this.lowerCaseObjectKeys);
						this.callbackOrLog(callback, null, data || null); })
					.error((err) => {
						this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdFertilityProtocolsByHerdFertilityPlanId(data, callback) {
			this.$http.get(this.prepareUrl('/data/herd-fertility-protocol/herd-fertility-plan/' + data.herdFertilityPlanId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdFertilityProtocolByHerdFertilityPlanIdAndProtocolTypeId(data, callback) {
			this.$http.get(this.prepareUrl('/data/herd-fertility-protocol/herd-fertility-plan/' + data.herdFertilityPlanId +
				'/protocol-type/' + data.protocolTypeId), this.sendHeaders())
					.success((data, status, headers) => {
						this.processHeaders(headers);
						data = this.lowerCaseObjectKeys(data);
						this.callbackOrLog(callback, null, data || null); })
					.error((err) => {
						this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdFertilityProgramsByHerdId(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/herd-fertility-program/herd/' + herdId), this.sendHeaders(performanceContext)).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		createHerdFertilityProgram(data, callback) {
			this.$http.post(this.prepareUrl('/data/herd-fertility-program'), {herdFertilityProgram: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateHerdFertilityProgram(data, callback) {
			this.$http.put(this.prepareUrl('/data/herd-fertility-program/' + data.herdFertilityProgramId), {herdFertilityProgram: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		deleteHerdFertilityProgram(herdFertilityProgramId, callback) {
			this.$http.delete(this.prepareUrl('/data/herd-fertility-program/' + herdFertilityProgramId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		createHerdFertilityPlan(data, callback) {
			this.$http.post(this.prepareUrl('/data/herd-fertility-plan'), {herdFertilityPlan: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateHerdFertilityPlan(data, callback) {
			this.$http.put(this.prepareUrl('/data/herd-fertility-plan/' + data.herdFertilityPlanId), {herdFertilityPlan: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		createHerdFertilityProtocol(data, callback) {
			this.$http.post(this.prepareUrl('/data/herd-fertility-protocol'), {herdFertilityProtocol: data}, this.sendHeaders()).success((data, status, headers) => {
				this.processHeaders(headers);
				this.callbackOrLog(callback, null, data || null);
			}).error((err) => {
				this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateHerdFertilityProtocol(data, callback) {
			var url = this.prepareUrl('/data/herd-fertility-protocol/' + data.herdFertilityProtocolId);
			this.$http.put(url, {herdFertilityProtocol: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		deleteHerdFertilityProtocol(herdFertilityProtocolId, callback) {
			this.$http.delete(this.prepareUrl('/data/herd-fertility-protocol/' + herdFertilityProtocolId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		login(loginData, callback) {
			this.$http.post(this.prepareUrl('/data/user/login'), loginData, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers, true);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		logout(logoutData, callback) {
			this.$http.post(this.prepareUrl('/data/user/logout'), logoutData, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getCohortDetails(herdCohortId, breedingWeek, callback) {
			this.$http.get(this.prepareUrl('/data/herd-cohort/herd/' + herdCohortId + 
				'/breeding-week/' + breedingWeek + '/details/'), this.sendHeaders())
					.success((data, status, headers) => {
						this.processHeaders(headers);
						data = _.map(data, this.lowerCaseObjectKeys);
						this.callbackOrLog(callback, null, data || null); })
					.error((err) => {
						this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getHerdCohortsByHerdId(herdId, callback) {
			this.$http.get(this.prepareUrl('/data/herd-cohort/herd/' + herdId), this.sendHeaders()).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		createUser(data, callback) {
			this.$http.post(this.prepareUrl('/data/user'), {user: data}, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		createFarmAndPerson(data, callback) {
			this.$http.post(this.prepareUrl('/data/farm/user'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getUserByPersonKey(personKey, callback) {
			this.$http.get(this.prepareUrl('/data/user/' + personKey), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = this.lowerCaseObjectKeys(data);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		removeUsersFromFarms(data, callback) {
			this.$http.put(this.prepareUrl('/data/user/farm/remove-from-farms'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		emailWhitePaper(data, callback) {
			this.$http.post(this.prepareUrl('/data/white-paper/email'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		emailSlide(data, callback) {
			this.$http.post(this.prepareUrl('/data/slide/email'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getBreedingCodesByHerdId(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/breeding-codes/' + herdId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, _.map(data, this.lowerCaseObjectKeys) || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		setBreedingCodesByHerdId(herdId, breedingCodes, callback) {
			this.$http.post(this.prepareUrl('/data/breeding-codes/' + herdId), breedingCodes, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateBreedingCodesByHerdId(herdId, breedingCodes, callback) {
			this.$http.put(this.prepareUrl('/data/breeding-codes/' + herdId), breedingCodes, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		}

		getBreederFertilityByHerdId(herdId, callback) {
			this.$http.get(this.prepareUrl('/data/breeder-fertility/herd/' + herdId), this.sendHeaders()).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		getSireFertilityByHerdId(herdId, callback) {
			this.$http.get(this.prepareUrl('/data/sire-fertility/herd/' + herdId), this.sendHeaders()).then(
				(response) => {
					this.processHeaders(response.headers);
					var data = _.map(response.data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null);
				},
				(response) => {
					var data = {
						statusCode: response.status,
						statusText: response.statusText
					};
					this.callbackOrLog(callback, response.data || 'unspecified', data);
				});
		};

		getTerritoryManagerByFarmId(farmId, callback) {	
			this.$http.get(this.prepareUrl('/data/territory-manager/farm/' + farmId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// ----- Admin Api Calls  -----
		getAllFarms(performanceContext,callback){
			this.$http.get(this.prepareUrl('/data/admin/farm/'), this.sendHeaders(performanceContext))
			.success((data, status, headers) => {
				this.processHeaders(headers);
				data = _.map(data, this.lowerCaseObjectKeys);
				this.callbackOrLog(callback, null, data || null); })
			.error((err) => {
				this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getFarmById(farmId, performanceContext, callback){
			this.$http.get(this.prepareUrl('/data/admin/farm/' + farmId), this.sendHeaders(performanceContext))
				.success((serverData, status, headers) => {
					this.processHeaders(headers);
					var serverDataJson = _.get(serverData,'Data',"[]");
					var data = {};
					try{
					data = JSON.parse(serverDataJson)[0];

					}catch(e){
						log.info("failed to parse returned farm data with farmId of "+ farmId);  
					}
					if(!_.isEmpty(data)){
						data = this.lowerCaseObjectKeys(data);

						_.forEach(_.keys(data),(key)=>{
							data[key] = this.lowerCaseObjectKeys(data[key]);
						});
					}
					
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		adminUpdateFarm(farmId, updateFarmData, callback) {
			var data = {farm: updateFarmData};
			this.$http.put(this.prepareUrl(`/data/admin/farm/update/${farmId}`), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		adminCreateFarm(createFarmData, callback) {
			var data = {farm: createFarmData};
			this.$http.post(this.prepareUrl('/data/admin/farm/create'), data, this.sendHeaders())
				.success((serverData, status, headers) => { this.processHeaders(headers);
					var serverDataJson = _.get(serverData,'Data',"[]");
					var data = {};
					try{
					data = JSON.parse(serverDataJson)[0];
					_.set(data,'FarmManager',	JSON.parse(_.get(data,'FarmManager')));
					_.set(data,'Farm',		JSON.parse(_.get(data,'Farm')));
					_.set(data,'Herd',		JSON.parse(_.get(data,'Herd')));

					}catch(e){
						log.info("failed to parse returned farm data with farmId of "+ _.get(createFarmData,'farmId',''));  
					}
					if(!_.isEmpty(data)){
						data = this.lowerCaseObjectKeys(data);

						_.forEach(_.keys(data),(key)=>{
							data[key] = this.lowerCaseObjectKeys(data[key]);
						});
					}

					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAllAdminUsers(performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/admin/user/'), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAdminUserById(personId, performanceContext, callback){
			this.$http.get(this.prepareUrl('/data/admin/user/'+ personId), this.sendHeaders(performanceContext))
				.success((serverData, status, headers) => { this.processHeaders(headers);
					var serverDataJson = _.get(serverData,'Data',"[]");
					var data = {};
					try{
					data = JSON.parse(serverDataJson)[0];

					}catch(e){
						log.info("failed to parse returned admin user data with personId of "+ personId);  
					}
					if(!_.isEmpty(data)){
						data = this.lowerCaseObjectKeys(data);

						_.forEach(_.keys(data),(key)=>{
							data[key] = this.lowerCaseObjectKeys(data[key]);
						});
					}
					
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateAdminUser(personId, adminUserData, callback) {
			var data = {adminUser: adminUserData};
			this.$http.put(this.prepareUrl(`/data/admin/user/update/${personId}`), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		adminCreateAdminUser(createAdminUserData, callback) {
			var data = {adminUser: createAdminUserData};
			this.$http.post(this.prepareUrl('/data/admin/user/create'), data, this.sendHeaders())
				.success((serverData, status, headers) => {
					this.processHeaders(headers);

					var serverDataJson = _.get(serverData,'Data',"[]");
					var data = {};
					try{
					data = JSON.parse(serverDataJson)[0];
					_.set(data,'Person',JSON.parse(_.get(data,'Person')));
					_.set(data,'PersonRole',JSON.parse(_.get(data,'PersonRole')));

					}catch(e){
						log.info("failed to parse returned farm data with farmId of "+ _.get(createAdminUserData,'farmId',''));  
					}
					if(!_.isEmpty(data)){
						data = this.lowerCaseObjectKeys(data);

						_.forEach(_.keys(data),(key)=>{
							data[key] = this.lowerCaseObjectKeys(data[key]);
						});
					}

					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		// --- Fertility 360 Routines --- //
		getFertility360AuditId(auditId, callback) {
			this.$http.get(this.prepareUrl('/data/fertility360/' + auditId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					data = _.map(data, this.lowerCaseObjectKeys);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getF360OnlineCheck(callback) {
			this.$http.get(this.prepareUrl('/data/f360-online-check'), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getSyncStatus(auditId, syncedOn, isDeviceDirty, performanceContext, callback) {
			var data = {auditId: auditId,lastSyncedDate: syncedOn,isDeviceDirty:isDeviceDirty};
			this.$http.post(this.prepareUrl('/data/f360-sync-status/' + auditId), data, this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getOverViewList(auditId, performanceContext = null, callback) {
			this.$http.get(this.prepareUrl('/data/f360/overview/' + auditId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getAuditSectionsData(auditId, callback) {
			this.$http.get(this.prepareUrl('/data/f360/sections-data/:auditId' + auditId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getQuestionList(auditId, performanceContext = null, callback) {
			this.$http.get(this.prepareUrl('/data/f360/questions/' + auditId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateAuditSectionsData(auditId, sectionsDataJson, callback) {
			var data = {sectionsDataJson: sectionsDataJson};
			this.$http.put(this.prepareUrl(`/data/f360/update/${auditId}/sections-data`), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		updateAnswer(auditId, answersJson, callback) {
			var data = {answersJson: answersJson};
			this.$http.put(this.prepareUrl(`/data/f360/update/${auditId}/answers`), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getListByHerdId(herdId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/f360/list/' + herdId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		
		updateListByHerdId(herdId, listJson, callback) {
			var data = {herdId: herdId,listJson: listJson};
			this.$http.put(this.prepareUrl('/data/f360/list/' + herdId + '/update'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		
		getPrePopulatedData(auditId, performanceContext, callback) {
			this.$http.get(this.prepareUrl('/data/f360/prepopulated-data/' + auditId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		getPenListData(auditId, performanceContext = null, callback) {
			this.$http.get(this.prepareUrl('/data/f360/pen-list-data/' + auditId), this.sendHeaders(performanceContext))
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		createNewAudit(auditApiVersion,herdId, personId, lact1, lact2, callback) {
			this.$http.get(this.prepareUrl(`/data/f360/create/${auditApiVersion}/${herdId}/user/${personId}/${lact1}/${lact2}`),
				this.sendHeaders()
			).success((data, status, headers) => {
				this.processHeaders(headers);
				this.callbackOrLog(callback, null, data || null);
			}).error((err) => {
				this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		deleteAuditbyAuditId(auditId, callback) {
			this.$http.get(this.prepareUrl('/data/f360/delete/' + auditId), this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};

		publishAudit(auditId, draftNotesJson, callback) {
			var data = {draftNotesJson: draftNotesJson};
			this.$http.put(this.prepareUrl('/data/f360/publish/' + auditId), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
		checkInOutAudit(data, callback) {
			this.$http.put(this.prepareUrl('/data/f360/checkinout'), data, this.sendHeaders())
				.success((data, status, headers) => {
					this.processHeaders(headers);
					this.callbackOrLog(callback, null, data || null); })
				.error((err) => {
					this.callbackOrLog(callback, err || 'unspecified');
			});
		};
//#endregion Hide 2	


      
		
	
}

angular.module('mySynch').service('ApiFactory',ApiFactory );

